(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ote-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ote-youtube')) {
    class OteYoutube extends HTMLElement {
      connectedCallback() {
        this.link = this.querySelector('a');
        this.onClick = (event) => {
          event.preventDefault();
          const iframe = document.createElement('iframe');
          const id = encodeURIComponent(this.dataset.videoId || '');
          iframe.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0&playsinline=1`;
          iframe.title = this.dataset.title || 'YouTube video';
          iframe.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen';
          iframe.allowFullscreen = true;
          this.replaceChildren(iframe);
          iframe.focus();
        };
        this.link?.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.link?.removeEventListener('click', this.onClick);
      }
    }
    customElements.define('ote-youtube', OteYoutube);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ote-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ote-hero-video')) {
    class OteHeroVideo extends HTMLElement {
      connectedCallback() {
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.videos = Array.from(this.querySelectorAll('video'));
        this.toggle = this.querySelector('.ote-hero__toggle');
        this.userPaused = false;
        this.abort = new AbortController();
        const { signal } = this.abort;

        this.toggle?.addEventListener('click', () => this.onToggle(), { signal });
        this.motion.addEventListener('change', () => this.sync(), { signal });
        for (const video of this.videos) {
          window.matchMedia(video.dataset.media).addEventListener('change', () => this.sync(), { signal });
          video.addEventListener('playing', () => video.classList.add('is-playing'), { signal });
        }
        this.sync();
      }

      disconnectedCallback() {
        this.abort?.abort();
      }

      activeVideo() {
        return this.videos.find((video) => window.matchMedia(video.dataset.media).matches);
      }

      sync() {
        const active = this.activeVideo();
        for (const video of this.videos) {
          if (video !== active) video.pause();
        }
        if (!active || this.motion.matches) {
          active?.pause();
          if (this.toggle) this.toggle.hidden = true;
          return;
        }
        if (this.toggle) this.toggle.hidden = false;
        if (this.userPaused) return;
        active.preload = 'auto';
        active.play().catch(() => {});
      }

      onToggle() {
        const active = this.activeVideo();
        if (!active || !this.toggle) return;
        this.userPaused = !active.paused;
        if (this.userPaused) {
          active.pause();
        } else {
          active.play().catch(() => {});
        }
        this.toggle.setAttribute('aria-pressed', String(this.userPaused));
        this.toggle.setAttribute(
          'aria-label',
          this.userPaused ? this.toggle.dataset.labelPlay : this.toggle.dataset.labelPause
        );
      }
    }
    customElements.define('ote-hero-video', OteHeroVideo);
  }

  } catch(e) { console.error(e); }
})();
})();
